import makeStateFilter from '../../../make-state-filter';

import { stateFilter as parentStateFilter } from '../batches.reducer.metadata';

const namespace = 'label-batch-status-modal';
const stateFilter = makeStateFilter(parentStateFilter, namespace);

export { namespace, stateFilter };
